"use client";

import { usePathname } from "next/navigation";
import en from "../locales/en.json";
import th from "../locales/th.json";
import zh from "../locales/zh.json";

const translations = { en, th, zh };

export default function useTranslation() {
  const pathname = usePathname();

  // Extract language from the URL (assumes URL like "/en/page" or "/th/page")
  const locale = pathname.split("/")[1] || "en";

  const t = (key) => translations[locale]?.[key] || key;

  return { t, locale };
}
